'use client';

import React, { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { TypeformSnippet } from 'components/shared/TypeformSnippet';
import { buildPerformanceLabTypeformTracking } from 'lib/analytics/buildTypeformTrackingParams';
import { PerformanceLabModalBodyScrollLock } from '../PerformanceLabModalBodyScrollLock';
import { GLP_SIGNUP_TYPEFORM_ID } from './glpTypeform';
import styles from './GlpSignUpTypeformModal.module.css';

type GlpSignUpTypeformModalProps = {
  flow?: string;
};

export const GlpSignUpTypeformModal: React.FC<GlpSignUpTypeformModalProps> = ({
  flow = 'pl_glp_signup',
}) => {
  const t = useTranslations('performance-lab');

  const trackingParams = useMemo(
    () => buildPerformanceLabTypeformTracking(flow),
    [flow],
  );

  return (
    <PerformanceLabModalBodyScrollLock>
      <div className={styles.modalRoot}>
        <div className={styles.typeformContainer}>
          <TypeformSnippet
            typeformId={GLP_SIGNUP_TYPEFORM_ID}
            frameTitle={t('glp.signUpTypeform.frameTitle')}
            className="typeform-container"
            trackingParams={trackingParams}
          />
        </div>
      </div>
    </PerformanceLabModalBodyScrollLock>
  );
};
